import { React, useState, useRef, useEffect } from "react";
import ClientLayout from "../components/layout/ClientLayout";
import { useParams } from "react-router-dom";
import "../../../assets/css/fullmarket.css";
import RightSide from "../markets/right-side";
import MatchOdd from "../markets/match-odd";
import Bookmaker from "../markets/bookmaker";
import Toss from "../markets/toss";
import BetfairFancy from "../markets/betfair-fancy";
import Fancy from "../markets/fancy";
import FootballFancy from "../markets/football-fancy";
import EvenOdd from "../markets/even-odd";
import CricketScoreBoard from "../markets/cricket-scoreboard"; 
import CricketScoreIframe from "../markets/cricket-score-iframe";

import FootBallScoreBoard from "../markets/football-scoreboard";
import TennisScoreBoard from "../markets/tennis-scoreboard";

import Tie from "../markets/tie";
import LastDigit from "../markets/last-digit";
import HrGrMatchOdd from "../markets/hr-gr-match-odd";
import PopUpBetSlip from "../markets/popup-betslip";
import RulesMatchOdd from "../popup/rules_match_odd";
import RulesHRGR from "../popup/rules_hr_gr";

import axiosInstance from "../../../utils/axiosInstance";
import useSocket from "../../../hooks/useSocket";
import moment from "moment";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setUserData } from "../../../store/userSlice";

import {
  db,
  addSession,
  getAllSession,
  addEvenOdd,
  getAllEvenOddList,
  deletAllTables,
  addFigure,
  getAllFigureist
} from "../../../db";

const FullMarkets = (sendDataToParent) => {
  let matchOdds = null;
  let bookmakerOdds = null;
  let tossData = null;
  let fancyData = null;
  let betfairFancyData = null;
  let tieData = null;
  let evenodddata = null;
  let figuredata = null;
  let footballFancy = null;
  let scoreboardData = null;
  let diamondScoreboardData = null;

  let toss = null;
  let inplay = false;
  let is_bm_on = false;
  let fancy = false;
  let tie = false;
  let betfairfancy = false;
  let figure = false;
  let evenodd = false;
  let game_type = 0;
  let tie_cat_mid = "";
  let LoginUserId = "";
  const dispatch = useDispatch();

  const { marketId } = useParams();
  const { data, isConnected } = useSocket({
    marketId: marketId,
    mtype: "sports",
    type: ""
  });
  //console.log("Socket connected:", isConnected);
  //console.log("Socket data:", data?.data?.odds);
  //console.log("Socket data odd:", data?.data?.odds);
  if (data !== null && data.user !== null && data.user !== undefined)
    dispatch(setUserData(data.user));
  LoginUserId = data?.user?._id;

  //console.log("Socket cat_mid:", data?.data);

  const [GameType, setGameType] = useState(0);
  const [activeTab, setActiveTab] = useState("");
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [showLoader, setShowHideLoader] = useState(false);
  const [eventDetails, setEventDetails] = useState({});
  const [relatedEvents, setRelatedEvents] = useState([]);
  const [betObj, setBetSlipDetails] = useState({});
  const [activeMarketList] = useState([]);
  const [eventStatus, setEventStatus] = useState("");
  const [isInplay, setIsInplay] = useState("");

  let matchOddBook = {
    rnr1s: 0,
    rnr2s: 0,
    rnr3s: 0
  };
  //const [matchOddBook, setMatchOddBook] = useState({});
  const [tieBook, setTieBook] = useState({});
  const [footballFancyBook, setFootballFancyBook] = useState([]);
  const [bookmakerBook, setBookmakerBook] = useState({});
  const [HRGRBook, setHRGRBook] = useState([]);
  const [betList, setBetList] = useState([]);
  const [unmatchedBetList, setUnmatchedBetList] = useState([]);
  const [stakeList, setStakeList] = useState({});

  const [timeLeft, setTimeLeft] = useState("");
  const [timeLeftInHour, setTimeLeftInHour] = useState("");

  const [show, setShow] = useState(false);
  const [showDesktopSlip, setDesktopSlip] = useState(false);

  const [showMatchOddRules, setShowMatchOddRules] = useState(false);
  const [showHRGRRules, setShowHRGRRules] = useState(false);

  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);

  const [getBetPlaceSessionList, setBetPlaceSessionList] = useState([]);
  const [getBetPlaceEvenOddList, setBetPlaceEvenOddList] = useState([]);
  const [getBetPlaceFigureList, setBetPlaceFigureList] = useState([]);
  const [getTieCatMid, setTieCatMid] = useState("");

  const [getBetDelayTime, setGetBetDelayTime] = useState([]);

  const userInfoObj = useSelector((state) => state.userStore);
  const userInfo = userInfoObj?.data;
  let OldData = null;
  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const setBetSlipParent = (betObj) => {
    if (isMobile) {
      setBetSlipDetails(betObj);
      setShow(true);
      setDesktopSlip(false);
    } else {
      setDesktopSlip(true);
      setShow(false);
      setBetSlipDetails(betObj);
      scrollToTop();
    }
  };

  const closeBetSlipMobile = () => {
    setShow(false);
    setBetErrorMessage({});
  };

  const ShowHideLoader = (value) => {
    setShowHideLoader(showLoader, value);
  };

  const setPageDisplaySetting = (eventData) => {
    if (eventData !== undefined) {
      setEventDetails(eventData);
      setEventStatus(eventData.evt_status);
      setIsInplay(eventData.inplay);
      setGameType(eventData.game_type);
      timeRemaining(eventData.evt_od);
      setTieCatMid(eventData.tie_cat_mid);
    }
  };

  const closeBetSlip = () => {
    setBetSlipDetails({});
    //setBetErrorMessage({});
  };

  const clearBetSlip = () => {
    setBetErrorMessage({});
  };

  const getDelayTime = (game_type, market_type) => {
    let defaultTime = 8;
    //console.log("game_type->", game_type);
    //console.log("market_type->", market_type);
    //console.log("market_type->", getBetDelayTime);
    if (getBetDelayTime) {
      let searchMarket = 1;
      if (game_type == 1 && market_type == "m") {
        searchMarket = 1;
      } else if (game_type == 1 && market_type == "bm") {
        searchMarket = 2;
      } else if (game_type == 1 && market_type == "f") {
        searchMarket = 3;
      } else if (game_type == 1 && market_type == "betfairfancy") {
        searchMarket = 3;
      } else if (game_type == 1 && market_type == "toss_fancy") {
        searchMarket = 4;
      } else if (game_type == 1 && market_type == "digit") {
        searchMarket = 6;
      } else if (game_type == 1 && market_type == "tie") {
        searchMarket = 7;
      } else if (game_type == 1 && market_type == "evenodd") {
        searchMarket = 8;
      } else if (game_type == 2 && market_type == "m") {
        searchMarket = 1;
      } else if (game_type == 2 && market_type == "ff") {
        searchMarket = 6;
      } else if (game_type == 3 && market_type == "m") {
        searchMarket = 1;
      } else if (game_type == 4) {
        searchMarket = 1;
      } else if (game_type == 5) {
        searchMarket = 1;
      }

      const resultObj = getBetDelayTime?.response.find(
        (obj) => obj.market_type === searchMarket && obj.game_type == game_type
      );

      if (resultObj) {
        defaultTime = resultObj.value;
      }
    } 
    return defaultTime;
  };

  //place bet code start here....
  const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

  const placeBet = async (amount) => {
    setButtonShowLoaderShow(true);
    setBetButtonShow(false);
    betObj.amount = amount;
    betObj.catmid = eventDetails.cat_mid;
    betObj.game_type = eventDetails.game_type;
    betObj.is_virtual = 0;

    let delayTime = getDelayTime(eventDetails.game_type, betObj.market_type);
    console.log("tttii->", delayTime);
    betObj.delay = delayTime;

    if (betObj.market_type === "digit" || betObj.market_type === "toss_fancy") {
      betObj.eventId = eventDetails.evt_id;
      betObj.price = betObj.odds;
    }

    if (
      betObj.market_type === "m" ||
      betObj.market_type === "ff" ||
      betObj.market_type === "evenodd" ||
      betObj.market_type === "digit" ||
      betObj.market_type === "f" ||
      betObj.market_type === "betfairfancy"
    ) {
      betObj.eventId = eventDetails.evt_id;
    }

    //console.log("eventDetails->",eventDetails);
    try {
      //console.log("delayTime->", delayTime);
      await sleep(delayTime * 1000);
      const response = await axiosInstance.post("/bets", betObj);
      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;

          if (
            betObj.market_type === "f" ||
            betObj.market_type === "betfairfancy" ||
            betObj.market_type === "toss_fancy"
          ) {
            let betSid = betObj.sid + "_" + response.data.bets_data.user_id;
            await addSession(betSid, response.data.nlocka);
            let sessionList = await getAllSession();
            setBetPlaceSessionList(sessionList);
          }

          if (betObj.market_type === "evenodd") {
            let sid = betObj.sid;
            let key = sid + "_" + LoginUserId;
            await addEvenOdd(key, response.data.betDetails);
            let evenOddList = await getAllEvenOddList();
            setBetPlaceEvenOddList(evenOddList);
          }

          if (betObj.market_type === "digit") {
            let sid = betObj.lastdigitid.$oid;
            let key = sid + "_" + LoginUserId;
            await addFigure(key, response.data.betDetails);
            let figureList = await getAllFigureist();
            setBetPlaceFigureList(figureList);
          }
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);

        if (
          eventDetails !== null &&
          (Number(eventDetails.game_type) === 4 ||
            Number(eventDetails.game_type) === 5)
        ) {
          getHRGRBook(marketId);
        }

        if (
          eventDetails !== null &&
          (eventDetails.game_type === 1 ||
            eventDetails.game_type === 2 ||
            eventDetails.game_type === 3)
        ) {
          getUserBookMatchOdd(marketId);
        }

        if (eventDetails !== null && eventDetails.game_type === 1) {
          getBookForBookMaker(marketId);
        }

        if (
          eventDetails !== null &&
          eventDetails.game_type === 1 &&
          betObj.market_type == "tie"
        ) {
          getUserBookTie(getTieCatMid);
        }

        if (eventDetails !== null && eventDetails.game_type === 2) {
          getUserFootballFancyBook(marketId);
        }

        //toast.success(response.data.message);
        getBetList(eventDetails.cat_mid);
        //fetchUserData(); //balance update on top
        setShow(false);
        setButtonShowLoaderShow(false);
        setBetButtonShow(true);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          //toast.error(errorMessage);
          setBetErrorMessage(messageObj);
          setButtonShowLoaderShow(false);
          setBetButtonShow(true);
        }
      }
    }
  };

  const timeRemaining = (eventDate) => {
    //useEffect(() => {
    const interval = setInterval(() => {
      const startDate = moment(); // current time
      const endDate = moment(eventDate); // your target date

      const duration = moment.duration(endDate.diff(startDate));

      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();
      if (minutes < 0) {
        const startDate = moment(eventDate); // your target date
        const endDate = moment(); // current time
        const duration = moment.duration(endDate.diff(startDate));
        const days = Math.floor(duration.asDays());
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        setTimeLeft(`${"Elapsed"}: ${hours}:${minutes}:${seconds}`);
        setTimeLeftInHour(`${"in"} ${hours} ${"hours"}`);
      } else {
        setTimeLeft(`${"Remaining"}: ${hours}:${minutes}:${seconds}`);
        setTimeLeftInHour(`${"in"} ${hours} ${"hours ago"}`);
      }
    }, 1000);

    return () => clearInterval(interval); // cleanup on unmount
    // }, []);
  };

  const showRulesPopup = () => {
    setShowMatchOddRules(true);
  };

  const showHRGRRulesPopup = () => {
    setShowHRGRRules(true);
  };

  const getBetList = async (marketId) => {
    const response = await axiosInstance.get("/markets/betlist/" + marketId);
    if (
      response.data !== null &&
      response.data.bets_list !== null &&
      response.data.bets_list !== undefined
    ) {
      setBetList(response.data.bets_list);
    } else {
      setBetList([]);
    }
    setUnmatchedBetList(
      (response.data?.unmatched_bets || []).filter(
        (bet) =>
          Number(bet.isDeleted ?? 0) === 0 && Number(bet.isSettled ?? 0) === 0
      )
    );
  };

  const getUserBookMatchOdd = async (marketId) => {
    const response = await axiosInstance.post("/markets/book/" + marketId, {
      market_type: 1
    });
    if (
      response.data !== null &&
      response.data.liveStat !== null &&
      response.data.liveStat !== undefined
    ) {
      let matchOddBook = {};
      matchOddBook.rnr1s = response.data.liveStat?.rnr1s;
      matchOddBook.rnr2s = response.data.liveStat?.rnr2s;
      matchOddBook.rnr3s = response.data.liveStat?.rnr3s;
      //setMatchOddBook(matchOddBook);
    }
  };

  const getUserBookTie = async (marketId) => {
    if (marketId != "" && marketId != undefined && marketId != null) {
      const response = await axiosInstance.post("/markets/book/" + marketId, {
        market_type: 5
      });
      if (
        response.data !== null &&
        response.data.liveStat !== null &&
        response.data.liveStat !== undefined
      ) {
        let tieBook = {};
        tieBook.rnr1s = response.data.liveStat?.rnr1s;
        tieBook.rnr2s = response.data.liveStat?.rnr2s;
        setTieBook(tieBook);
      }
    }
  };

  const getUserFootballFancyBook = async (marketId) => {
    const response = await axiosInstance.post("/markets/book/ff/" + marketId, {
      market_type: 6
    });

    if (
      response.data !== null &&
      response.data.lstBook !== null &&
      response.data.lstBook !== undefined
    ) {
      setFootballFancyBook(response.data.lstBook);
    }
  };

  const getBookForBookMaker = async (marketId) => {
    const response = await axiosInstance.post("/markets/book/" + marketId, {
      market_type: 2
    });
    if (
      response.data !== null &&
      response.data.liveStat !== null &&
      response.data.liveStat !== undefined
    ) {
      let bookMakerBook = {};
      bookMakerBook.rnr1s = response.data.liveStat?.rnr1s;
      bookMakerBook.rnr2s = response.data.liveStat?.rnr2s;
      bookMakerBook.rnr3s = response.data.liveStat?.rnr3s;
      setBookmakerBook(bookMakerBook);
    }
  };

  const getHRGRBook = async (marketId) => {
    const response = await axiosInstance.post(
      "/markets/hr-gr-book/" + marketId,
      { market_type: 1 }
    );
    if (
      response.data !== null &&
      response.data.book_list !== null &&
      response.data.book_list !== undefined
    ) {
      setHRGRBook(response.data.book_list);
      /*let bookMakerBook = {};
        bookMakerBook.rnr1s = response.data.liveStat?.rnr1s;
        bookMakerBook.rnr2s = response.data.liveStat?.rnr2s;
        bookMakerBook.rnr3s = response.data.liveStat?.rnr3s;
        setBookmakerBook(bookMakerBook); */
    }
  };

  const getRelatedEvents = async (marketId) => {
    try {
      const response = await axiosInstance.get(
        "/markets/related-events/" + marketId
      );
      if (
        response.data !== null &&
        response.data.relatedEvents !== null &&
        response.data.relatedEvents !== undefined
      ) {
        let relatedEvents = response.data.relatedEvents;
        setRelatedEvents(relatedEvents);
      }
    } catch (error) {
      console.error("Error fetching single event:", error);
    }
  };

  const fetchEventsById = async (marketId) => {
    //console.log("Fetching Single event...");
    try {
      //ShowHideLoader(true);

      const response = await axiosInstance.get("/events/" + marketId);

      if (
        response.data !== null &&
        response.data.event !== null &&
        response.data.event !== undefined
      ) {
        setPageDisplaySetting(response.data.event[0]);

        let eventDetails = response.data.event[0];
        //console.log("eventDetails->",eventDetails);
        if (
          eventDetails !== null &&
          (Number(eventDetails.game_type) === 4 ||
            Number(eventDetails.game_type) === 5)
        ) {
          getHRGRBook(marketId);
        }

        if (
          eventDetails !== null &&
          (eventDetails.game_type == 1 ||
            eventDetails.game_type == 2 ||
            eventDetails.game_type == 3)
        ) {
          getUserBookMatchOdd(marketId);
        }

        if (eventDetails !== null && eventDetails.game_type === 1) {
          getBookForBookMaker(marketId);
        }

        if (eventDetails !== null && eventDetails.game_type === 1) {
          getUserBookTie(eventDetails.tie_cat_mid);
        }

        if (eventDetails !== null && eventDetails.game_type === 2) {
          getUserFootballFancyBook(marketId);
        }

        getBetList(marketId);

        let sessionList = await getAllSession();
        setBetPlaceSessionList(sessionList);

        let evenOddList = await getAllEvenOddList();
        setBetPlaceEvenOddList(evenOddList);

        let getFigureList = await getAllFigureist();
        setBetPlaceFigureList(getFigureList);
      }
      //console.log(response.data); // single event data
    } catch (error) {
      console.error("Error fetching single event:", error);
    }
  };

  const getDelayTimes = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/event-limits");
      setGetBetDelayTime(data);
      //console.log("data->", data);
    } catch (error) {
      console.error("Failed to load getDelayTimes data:", error);
    }
  };

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setStakeList({
        stake1: data.stake1,
        stake2: data.stake2,
        stake3: data.stake3,
        stake4: data.stake4,
        stake5: data.stake5,
        stake6: data.stake6,
        stake7: data.stake7,
        stake8: data.stake8
      });
    } catch (error) {
      console.error("Failed to load profile data:", error);
    }
  };

  //Get Event Details By CatMid
  useEffect(() => {
    fetchEventsById(marketId);
    getRelatedEvents(marketId);
    fetchProfile();
    getDelayTimes();
  }, []); // Empty dependency array

  const fetchUserData = async () => {
    //console.log("Fetching events...");
    try {
      const response = await axiosInstance.get("/user");
      //console.log("user-response->",response);
      if (response.data !== "") {
        await dispatch(setUserData(response.data));
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  let newEventStatus = "";

  if (data !== null && data.data !== null && data.data !== undefined) {
    if (data.data.odds !== null && data.data.odds !== undefined) {
      matchOdds = data.data.odds;
      //console.log("matchOdds->", matchOdds);
      inplay = matchOdds.inplay;
      is_bm_on = matchOdds.is_bm_on;
      fancy = matchOdds.fancy;
      toss = matchOdds.toss_on;
      tie = matchOdds.tie_on;

      betfairfancy = matchOdds.bf_fancy_on;
      if (betfairfancy == undefined) {
        betfairfancy = 0;
      }

      figure = matchOdds.figure;
      evenodd = matchOdds.evenodd;
      game_type = matchOdds.game_type;
      tie_cat_mid = matchOdds.tie_cat_mid;
      if (GameType == 4 || GameType == 5) {
        const firstKey = Object.keys(matchOdds)[0];
        const firstObject = matchOdds[firstKey];
        if (firstObject != null && firstObject != undefined) {
          newEventStatus = firstObject?.event_status;
        }
      } else {
        newEventStatus = eventStatus;
      }

      if (betfairfancy == "0") {
        betfairfancy = false;
      } else {
        betfairfancy = true;
      }
      //console.log("betfairfancy->", betfairfancy);
      //fancy on/off
      if (!fancy) {
        let findFancyIndex = activeMarketList.indexOf("fancy2");
        if (findFancyIndex >= 0) {
          activeMarketList.splice(findFancyIndex, 1);
        }
      } else {
        let findFancyIndex = activeMarketList.indexOf("fancy2");
        if (findFancyIndex < 0) {
          activeMarketList.push("fancy2");
        }
      }

      //betfair fancy on/off
      if (game_type == 1) {
        if (!betfairfancy) {
          let findBFFancyIndex = activeMarketList.indexOf("fancy");
          if (findBFFancyIndex >= 0) {
            activeMarketList.splice(findBFFancyIndex, 1);
          }
        } else {
          let findBFFancyIndex = activeMarketList.indexOf("fancy");
          if (findBFFancyIndex < 0) {
            activeMarketList.push("fancy");
          }
        }
      }

      //toss on/off
      if (inplay) {
        let findTossIndex = activeMarketList.indexOf("toss");
        if (findTossIndex >= 0) {
          activeMarketList.splice(findTossIndex, 1);
        }
      } else {
        if (!toss) {
          let findTossIndex = activeMarketList.indexOf("toss");
          if (findTossIndex >= 0) {
            activeMarketList.splice(findTossIndex, 1);
          }
        } else {
          let findTossIndex = activeMarketList.indexOf("toss");
          if (findTossIndex < 0) {
            activeMarketList.push("toss");
          }
        }
      }

      //bookmaker on/off
      if (!is_bm_on) {
        let findBookmakerIndex = activeMarketList.indexOf("bookmaker");
        if (findBookmakerIndex >= 0) {
          activeMarketList.splice(findBookmakerIndex, 1);
        }
      } else {
        let findBookmakerIndex = activeMarketList.indexOf("bookmaker");
        if (findBookmakerIndex < 0) {
          activeMarketList.push("bookmaker");
        }
      }

      //tie on/off
      if (!tie) {
        let findTieIndex = activeMarketList.indexOf("tie");
        if (findTieIndex >= 0) {
          activeMarketList.splice(findTieIndex, 1);
        }
      } else {
        let findTieIndex = activeMarketList.indexOf("tie");
        if (findTieIndex < 0) {
          activeMarketList.push("tie");
        }
      }

      //evenodd
      if (!evenodd) {
        let findEvenOddIndex = activeMarketList.indexOf("even_odd");
        if (findEvenOddIndex >= 0) {
          activeMarketList.splice(findEvenOddIndex, 1);
        }
      } else {
        let findEvenOddIndex = activeMarketList.indexOf("even_odd");
        if (findEvenOddIndex < 0) {
          activeMarketList.push("even_odd");
        }
      }

      //figure
      if (!figure) {
        let findFigureIndex = activeMarketList.indexOf("other");
        if (findFigureIndex >= 0) {
          activeMarketList.splice(findFigureIndex, 1);
        }
      } else {
        let findFigureIndex = activeMarketList.indexOf("other");
        if (findFigureIndex < 0) {
          activeMarketList.push("other");
        }
      }

      //console.log("activeMarketList->", activeMarketList);
    }

    if (data.data.bookmaker !== null && data.data.bookmaker !== undefined) {
      bookmakerOdds = data.data.bookmaker;
    }

    if (
      data.data.betfairFancy !== null &&
      data.data.betfairFancy !== undefined
    ) {
      betfairFancyData = data.data.betfairFancy;
    }

    if (inplay === 0) {
      if (data.data.toss !== null && data.data.toss !== undefined) {
        tossData = data.data.toss;
      }
    }

    if (data.data.fancy !== null && data.data.fancy !== undefined) {
      fancyData = data.data.fancy;
    }

    if (inplay === 0 || inplay === 1) {
      if (data.data.tiedds !== null && data.data.tiedds !== undefined) {
        tieData = data.data.tiedds;
      } else {
        //console.log("tieData not found....",tieData);
      }

      if (
        data.data.evenodddata !== null &&
        data.data.evenodddata !== undefined
      ) {
        evenodddata = data.data.evenodddata;
      }

      if (data.data.figuredata !== null && data.data.figuredata !== undefined) {
        figuredata = data.data.figuredata;
      }

      if (
        data.data.footballFancy !== null &&
        data.data.footballFancy !== undefined
      ) {
        footballFancy = data.data.footballFancy;
      }

      if (
        data.data.fancyScoreBoard !== null &&
        data.data.fancyScoreBoard !== undefined
      ) {
        scoreboardData = data.data.fancyScoreBoard;
      }

      if (
        data.data.scoreCrick !== null &&
        data.data.scoreCrick?.data !== undefined
      ) {
        diamondScoreboardData = data.data.scoreCrick.data;
      }

      if (data.data.book !== null && data.data.book?.liveStat !== undefined) {
        //let matchOddBook = {};

        matchOddBook.rnr1s = data.data.book.liveStat?.rnr1s;
        matchOddBook.rnr2s = data.data.book.liveStat?.rnr2s;
        matchOddBook.rnr3s = data.data.book.liveStat?.rnr3s;

        //setSocketBookData(matchOddBook);
      }
    }
  }

  function displayTime(evt_od) {
    evt_od = new Date(evt_od);
    let mongoTime = evt_od;
    let eventDate = moment(Number(mongoTime)).local().format("hh:mm A");
    return eventDate;
  }

  const deleteAllTables = async () => {
    //deletAllTables();
    let evenOddList = await getAllEvenOddList();
    let figureList = await getAllFigureist();
  };

  return (
    <ClientLayout>
      <div className="">
        <div className="row right-side-row" style={{ margin: "5px 0" }}>
          <div
            className="col-md-8"
            style={{ paddingRight: "0px", paddingLeft: "0px" }}
          >
            <div className="left-content">
              <div className="table-wrap">
                <div className="table-box-header">
                  <div className="row no-gutters">
                    <div className="col-md-auto">
                      <div className="box-main-icon">
                        {GameType == 1 ? (
                          <img
                            src="/assets/images/cricket.svg"
                            style={{ width: "34px", height: "34px" }}
                            alt="Box Icon"
                          />
                        ) : (
                          ""
                        )}
                        {GameType == 2 ? (
                          <img
                            src="/assets/images/soccer.svg"
                            style={{ width: "34px", height: "34px" }}
                            alt="Box Icon"
                          />
                        ) : (
                          ""
                        )}
                        {GameType == 3 ? (
                          <img
                            src="/assets/images/tennis.svg"
                            style={{ width: "34px", height: "34px" }}
                            alt="Box Icon"
                          />
                        ) : (
                          ""
                        )}
                        {GameType == 4 ? (
                          <img
                            src="/assets/images/horse.svg"
                            style={{ width: "34px", height: "34px" }}
                            alt="Box Icon"
                          />
                        ) : (
                          ""
                        )}
                        {GameType == 5 ? (
                          <img
                            src="/assets/images/greyhound-racing.svg"
                            style={{ width: "34px", height: "34px" }}
                            alt="Box Icon"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-md">
                      <div className="tb-top-text">
                        <p>
                          <img src="/assets/images/clock-green.svg" />
                          <span className="green-upper-text">
                            <span
                              style={{
                                display:
                                  GameType == 1 ||
                                  GameType == 2 ||
                                  GameType == 3
                                    ? ""
                                    : "none"
                              }}
                            >
                              {isInplay == 1 ? "Inplay" : newEventStatus}
                            </span>
                            <span
                              style={{
                                display:
                                  GameType == 4 || GameType == 4 ? "" : "none"
                              }}
                            >
                              {newEventStatus}
                            </span>
                            <span
                              className="sleep-off mobHideDeskShow"
                              style={{ lineHeight: "0px" }}
                            >
                              <input
                                type="checkbox"
                                name="is_display_on"
                                id="is_display_on"
                                value="1"
                              />
                              <label
                                for="is_display_on"
                                style={{
                                  color: "white",
                                  fontSize: "15px",
                                  textTransform: "math-auto"
                                }}
                              >
                                <a onClick={() => deleteAllTables()}>
                                  Keep Display On
                                </a>
                              </label>
                            </span>
                            <audio id="myAudio">
                              <source id="audio_src" src="" type="audio/mpeg" />
                              Your browser does not support the audio element.
                            </audio>
                          </span>
                          <span className="black-light-text">
                            {" "}
                            {timeLeftInHour} |{" "}
                            {moment
                              .utc(eventDetails.evt_od)
                              .local()
                              .format("MMM D hh:mm a")}{" "}
                            | Winners: 1
                          </span>
                        </p>

                        <h4 className="event-title">
                          <span
                            style={{
                              display:
                                GameType == 4 || GameType == 5 ? "" : "none"
                            }}
                          >
                            {displayTime(eventDetails.evt_od)}
                          </span>{" "}
                          {eventDetails.evt_evt}
                        </h4>

                        <b style={{ color: "white" }}>
                          <span className="medium-black">{timeLeft}</span>
                        </b>

                        <span
                          className="sleep-off mobShowDeskHide"
                          style={{
                            lineHeight: "0px",
                            marginTop: "5px",
                            marginBottom: "10px"
                          }}
                        >
                          <input
                            type="checkbox"
                            name="is_display_on"
                            id="is_display_on"
                            value="1"
                          />
                          <label
                            for="is_display_on"
                            style={{
                              color: "white",
                              fontSize: "15px",
                              textTransform: "math-auto"
                            }}
                          >
                            Keep Display On
                          </label>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="scrollmenu"></div>
                </div>

                <div className="details-tabs-wrapper1">
                  <div>
                    <ul
                      className="nav nav-tabs"
                      role="tablist"
                      style={{
                        overflow: "auto",
                        width: "100%",
                        display: "flex",
                        flexWrap: "nowrap",
                        listStyle: "none"
                      }}
                    >
                      <div
                        style={{
                          float: "left",
                          textAlign: "center",
                          color: "white",
                          flex: "0 0 auto",
                          display:
                            GameType == 3 || GameType == 4 || GameType == 5
                              ? "none"
                              : ""
                        }}
                        className={
                          activeTab === "all" ? "tabSelected" : "tabUnselected"
                        }
                        onClick={() => setActiveTab("all")}
                      >
                        ALL
                      </div>

                      <div
                        style={{
                          float: "left",
                          textAlign: "center",
                          color: "white",
                          flex: "0 0 auto",
                          display: activeMarketList.includes("toss")
                            ? "block"
                            : "none"
                        }}
                        className={
                          activeTab === "toss" ? "tabSelected" : "tabUnselected"
                        }
                        onClick={() => setActiveTab("toss")}
                      >
                        Toss
                      </div>

                      <div
                        style={{
                          float: "left",
                          textAlign: "center",
                          color: "white",
                          flex: "0 0 auto",
                          display: activeMarketList.includes("bookmaker")
                            ? "block"
                            : "none"
                        }}
                        className={
                          activeTab === "bookmaker"
                            ? "tabSelected"
                            : "tabUnselected"
                        }
                        onClick={() => setActiveTab("bookmaker")}
                      >
                        Bookmaker
                      </div>

                      <div
                        style={{
                          float: "left",
                          textAlign: "center",
                          color: "white",
                          flex: "0 0 auto",
                          display: activeMarketList.includes("fancy2")
                            ? "block"
                            : "none"
                        }}
                        className={
                          activeTab === "fancy2"
                            ? "tabSelected"
                            : "tabUnselected"
                        }
                        onClick={() => setActiveTab("fancy2")}
                      >
                        {game_type == 2 ? "Other" : "Fancy-2"}
                      </div>

                      <div
                        style={{
                          float: "left",
                          textAlign: "center",
                          color: "white",
                          width: "130px",
                          flex: "0 0 auto",
                          display: activeMarketList.includes("fancy")
                            ? "block"
                            : "none"
                        }}
                        className={
                          activeTab === "fancy"
                            ? "tabSelected"
                            : "tabUnselected"
                        }
                        onClick={() => setActiveTab("fancy")}
                      >
                        Betfair Fancy
                      </div>

                      <div
                        style={{
                          float: "left",
                          textAlign: "center",
                          color: "white",
                          flex: "0 0 auto",
                          display: activeMarketList.includes("tie")
                            ? "block"
                            : "none"
                        }}
                        className={
                          activeTab === "tie" ? "tabSelected" : "tabUnselected"
                        }
                        onClick={() => setActiveTab("tie")}
                      >
                        Tie
                      </div>

                      <div
                        style={{
                          float: "left",
                          textAlign: "center",
                          color: "white",
                          flex: "0 0 auto",
                          display: activeMarketList.includes("even_odd")
                            ? "block"
                            : "none"
                        }}
                        className={
                          activeTab === "even_odd"
                            ? "tabSelected"
                            : "tabUnselected"
                        }
                        onClick={() => setActiveTab("even_odd")}
                      >
                        Even Odd
                      </div>

                      <div
                        style={{
                          float: "left",
                          textAlign: "center",
                          color: "white",
                          flex: "0 0 auto",
                          display: activeMarketList.includes("other")
                            ? "block"
                            : "none"
                        }}
                        className={
                          activeTab === "other"
                            ? "tabSelected"
                            : "tabUnselected"
                        }
                        onClick={() => setActiveTab("other")}
                      >
                        Other
                      </div>
                    </ul>
                  </div>

                  <div className="tab-content" style={{ marginTop: "2px" }}>
                    {GameType === 1 &&
                    eventDetails != null &&
                    scoreboardData !== null &&
                    eventDetails.inplay === 1 ? (
                      <div>
                        <CricketScoreBoard
                          eventDetails={eventDetails}
                          scoreboardData={scoreboardData}
                        ></CricketScoreBoard>
                      </div>
                    ) : (
                      <div>
                        {/*
                          <CricketScoreBoard
                            eventDetails={eventDetails}
                            scoreboardData={scoreboardData}
                          ></CricketScoreBoard>

                          <CricketScoreIframe
                        diamondScoreboardData={diamondScoreboardData}
                    ></CricketScoreIframe>*/}
                      </div>
                    )}

                    {GameType === 2 &&
                    eventDetails != null &&
                    scoreboardData !== null &&
                    eventDetails.inplay === 1 ? (
                      <div>
                        <FootBallScoreBoard
                          eventDetails={eventDetails}
                          scoreboardData={scoreboardData}
                        ></FootBallScoreBoard>
                      </div>
                    ) : (
                      ""
                    )}

                    {eventDetails !== null &&
                    GameType === 3 &&
                    scoreboardData !== null &&
                    eventDetails.inplay === 1 ? (
                      <div>
                        <TennisScoreBoard
                          eventDetails={eventDetails}
                          scoreboardData={scoreboardData}
                        ></TennisScoreBoard>
                      </div>
                    ) : (
                      ""
                    )}

                    <div
                      className="tab-pane active"
                      id="details-tabs-1"
                      role="tabpanel"
                    >
                      <div
                        style={{
                          display:
                            (activeTab === "all" || activeTab == "") &&
                            GameType !== 4 &&
                            GameType !== 5
                              ? "block"
                              : "none"
                        }}
                      >
                        {GameType === 1 || GameType === 2 || GameType === 3 ? (
                          <MatchOdd
                            onChildRuleShow={showRulesPopup}
                            eventDetails={eventDetails}
                            matchOdds={matchOdds}
                            setBetSlipDetails={setBetSlipParent}
                            matchOddBook={matchOddBook}
                          ></MatchOdd>
                        ) : (
                          ""
                        )}
                      </div>
                      <div
                        style={{
                          background: "var(--theme-bg-color)",
                          display: GameType == 2 || GameType == 3 ? "" : "none"
                        }}
                      >
                        <div
                          style={{
                            margin: "0px 5px",
                            padding: "5px",
                            background: "var(--theme-bg-color)"
                          }}
                        >
                          <p
                            style={{
                              textAlign: "left",
                              margin: "10px",
                              padding: "5px",
                              fontSize: "16px",
                              fontWeight: "inherit",
                              color: "red",
                              borderTop: "1px solid #d3d3d3",
                              borderBottom: "1px solid #d3d3d3"
                            }}
                          >
                            <b>LIVE VIDEO AVAILABLE</b>
                          </p>
                        </div>
                      </div>

                      <div
                        style={{
                          display:
                            (activeTab === "all" || activeTab == "") &&
                            (GameType === 4 || GameType === 5)
                              ? "block"
                              : "none"
                        }}
                      >
                        {GameType === 4 || GameType === 5 ? (
                          <HrGrMatchOdd
                            eventDetails={eventDetails}
                            matchOdds={matchOdds}
                            setBetSlipDetails={setBetSlipParent}
                            HRGRBook={HRGRBook}
                            onChildRuleShow={showHRGRRulesPopup}
                          ></HrGrMatchOdd>
                        ) : (
                          ""
                        )}
                      </div>

                      <div
                        style={{
                          display:
                            activeMarketList.includes("toss") && GameType === 1
                              ? "block"
                              : "none"
                        }}
                      >
                        <div
                          className="table-box-body"
                          style={{
                            display:
                              (activeTab === "all" ||
                                activeTab == "" ||
                                activeTab === "toss") &&
                              game_type === 1
                                ? "block"
                                : "none"
                          }}
                        >
                          {GameType === 1 ? (
                            <Toss
                              eventDetails={eventDetails}
                              tossData={tossData}
                              setBetSlipDetails={setBetSlipParent}
                              getBetPlaceSessionList={getBetPlaceSessionList}
                              userInfo={userInfo}
                            ></Toss>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div
                        style={{
                          display:
                            activeMarketList.includes("bookmaker") &&
                            GameType === 1
                              ? "block"
                              : "none"
                        }}
                      >
                        <div
                          className="table-box-body"
                          style={{
                            display:
                              (activeTab === "all" ||
                                activeTab == "" ||
                                activeTab === "bookmaker") &&
                              game_type === 1
                                ? "block"
                                : "none"
                          }}
                        >
                          {GameType === 1 ? (
                            <Bookmaker
                              onChildRuleShow={showRulesPopup}
                              eventDetails={eventDetails}
                              bookmakerOdds={bookmakerOdds}
                              setBetSlipDetails={setBetSlipParent}
                              bookmakerBook={bookmakerBook}
                            ></Bookmaker>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div
                        style={{
                          display:
                            activeMarketList.includes("fancy") && GameType === 1
                              ? "block"
                              : "none"
                        }}
                      >
                        <div
                          className="table-box-body"
                          style={{
                            display:
                              activeTab === "all" ||
                              activeTab == "" ||
                              activeTab === "fancy"
                                ? "block"
                                : "none"
                          }}
                        >
                          {GameType === 1 ? (
                            <BetfairFancy
                              eventDetails={eventDetails}
                              betfairFancyData={betfairFancyData}
                              setBetSlipDetails={setBetSlipParent}
                              getBetPlaceSessionList={getBetPlaceSessionList}
                              userInfo={userInfo}
                              onChildRuleShow={showRulesPopup}
                            ></BetfairFancy>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div
                        style={{
                          display:
                            activeMarketList.includes("fancy2") &&
                            GameType === 1
                              ? "block"
                              : "none"
                        }}
                      >
                        <div
                          className="table-box-body"
                          style={{
                            display:
                              (activeTab === "all" ||
                                activeTab == "" ||
                                activeTab === "fancy2") &&
                              game_type === 1
                                ? "block"
                                : "none"
                          }}
                        >
                          {GameType === 1 ? (
                            <Fancy
                              eventDetails={eventDetails}
                              fancyData={fancyData}
                              setBetSlipDetails={setBetSlipParent}
                              getBetPlaceSessionList={getBetPlaceSessionList}
                              userInfo={userInfo}
                            ></Fancy>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div
                        className="table-box-body"
                        style={{
                          display:
                            (activeTab === "all" ||
                              activeTab == "" ||
                              activeTab === "fancy2") &&
                            GameType === 2
                              ? "block"
                              : "none"
                        }}
                      >
                        {GameType === 2 ? (
                          <FootballFancy
                            eventDetails={eventDetails}
                            footballFancy={footballFancy}
                            setBetSlipDetails={setBetSlipParent}
                            footballFancyBook={footballFancyBook}
                          ></FootballFancy>
                        ) : (
                          ""
                        )}
                      </div>

                      <div
                        style={{
                          display:
                            activeMarketList.includes("tie") && GameType === 1
                              ? "block"
                              : "none"
                        }}
                      >
                        <div
                          className="table-box-body"
                          style={{
                            display:
                              activeTab === "all" ||
                              activeTab == "" ||
                              activeTab === "tie"
                                ? "block"
                                : "none"
                          }}
                        >
                          {GameType === 1 ? (
                            <Tie
                              eventDetails={eventDetails}
                              tieData={tieData}
                              setBetSlipDetails={setBetSlipParent}
                              tieBook={tieBook}
                              onChildRuleShow={showRulesPopup}
                            ></Tie>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div
                        style={{
                          display:
                            activeMarketList.includes("other") && GameType === 1
                              ? "block"
                              : "none"
                        }}
                      >
                        <div
                          className="table-box-body"
                          style={{
                            display:
                              (activeTab === "all" ||
                                activeTab == "" ||
                                activeTab === "other") &&
                              game_type === 1
                                ? "block"
                                : "none"
                          }}
                        >
                          {GameType === 1 ? (
                            <LastDigit
                              eventDetails={eventDetails}
                              figuredata={figuredata}
                              setBetSlipDetails={setBetSlipParent}
                              LoginUserId={LoginUserId}
                              getBetPlaceFigureList={getBetPlaceFigureList}
                            ></LastDigit>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div
                        style={{
                          display:
                            activeMarketList.includes("even_odd") &&
                            GameType === 1
                              ? "block"
                              : "none"
                        }}
                      >
                        <div
                          className="table-box-body"
                          style={{
                            display:
                              (activeTab === "all" ||
                                activeTab == "" ||
                                activeTab === "even_odd") &&
                              game_type === 1
                                ? "block"
                                : "none"
                          }}
                        >
                          {GameType === 1 ? (
                            <EvenOdd
                              eventDetails={eventDetails}
                              evenodddata={evenodddata}
                              setBetSlipDetails={setBetSlipParent}
                              getBetPlaceEvenOddList={getBetPlaceEvenOddList}
                              onChildRuleShow={showRulesPopup}
                              LoginUserId={LoginUserId}
                            ></EvenOdd>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {show && (
            <div>
              <PopUpBetSlip
                closeBetSlipParent={closeBetSlipMobile}
                betObj={betObj}
                placeBetParent={placeBet}
                betButtonShow={betButtonShow}
                betErrorMessageObj={betErrorMessageObj}
                betButtonShowLoaderShow={betButtonShowLoaderShow}
                stakeList={stakeList}
              ></PopUpBetSlip>
            </div>
          )}

          {showMatchOddRules && (
            <div>
              <RulesMatchOdd
                onClose={() => setShowMatchOddRules(false)}
              ></RulesMatchOdd>
            </div>
          )}

          {showHRGRRules && (
            <div>
              <RulesHRGR onClose={() => setShowHRGRRules(false)}></RulesHRGR>
            </div>
          )}

          <div
            className="col-md-4 padding-none-wrapper"
            style={{ paddingLeft: "6px" }}
          >
            <RightSide
              matchOdds={matchOdds}
              betObj={betObj}
              closeBetSlipParent={closeBetSlip}
              placeBetParent={placeBet}
              betErrorMessageObj={betErrorMessageObj}
              clearBetSlipParent={clearBetSlip}
              relatedEvents={relatedEvents}
              betList={betList}
              unmatchedBetList={unmatchedBetList}
              stakeList={stakeList}
              showDesktopSlip={showDesktopSlip}
              eventDetails={eventDetails}
              refreshBetListParent={() =>
                eventDetails?.cat_mid && getBetList(eventDetails.cat_mid)
              }
            ></RightSide>
          </div>
        </div>
      </div>
      <ToastContainer />
    </ClientLayout>
  );
};
export default FullMarkets;
